import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView'
import LoginView from '@/views/LoginView'
import NewsView from '@/views/NewsView'
import VisitNewView from '@/views/VisitNewView'
import NewNewView from '@/views/NewNewView'
import NewStaticPageView from '@/views/NewStaticPageView'
import VisitStaticPageView from '@/views/VisitStaticPageView'
import SchoolView from '@/views/SchoolView'

const schools = ["ali-ibn-musa", "karimeh", "sadr", "imam-javad", "imam-kazem", "imam-sadeq", "markaz-qom", "markaz-tehran", "women-tehran", "women-qom"];

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/:locale(fa)',
        name: 'home-farsi',
        component: HomeView
    },
    {
        path: '/:locale(ar)',
        name: 'home-arabic',
        component: HomeView
    },
    {
        path: '/:school(' + schools.join("|") + ')',
        name: 'school',
        component: SchoolView
    },
    {
        path: '/:locale(fa)/:school(' + schools.join("|") + ')',
        name: 'school-farsi',
        component: SchoolView
    },
    {
        path: '/:locale(ar)/:school(' + schools.join("|") + ')',
        name: 'school-arabic',
        component: SchoolView
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView
    },
    {
        path: '/:locale(fa)/login',
        name: 'login-farsi',
        component: LoginView
    },
    {
        path: '/:locale(ar)/login',
        name: 'login-arabic',
        component: LoginView
    },
    {
        path: '/news/:topic([a-z_]+)?',
        name: 'news',
        component: NewsView
    },
    {
        path: '/:locale(fa)/news/:topic([a-z_]+)?',
        name: 'news-farsi',
        component: NewsView
    },
    {
        path: '/:locale(ar)/news/:topic([a-z_]+)?',
        name: 'news-arabic',
        component: NewsView
    },
    {
        path: '/:school(' + schools.join("|") + ')/news',
        name: 'schoolNews',
        component: NewsView
    },
    {
        path: '/:locale(fa)/:school(' + schools.join("|") + ')/news',
        name: 'schoolNews-farsi',
        component: NewsView
    },
    {
        path: '/:locale(ar)/:school(' + schools.join("|") + ')/news',
        name: 'schoolNews-arabic',
        component: NewsView
    },
    {
        path: '/gallery',
        name: 'gallery',
        component: NewsView
    },
    {
        path: '/:locale(fa)/gallery',
        name: 'gallery-farsi',
        component: NewsView
    },
    {
        path: '/:locale(ar)/gallery',
        name: 'gallery-arabic',
        component: NewsView
    },
    {
        path: '/visit/:newID(\\d+):title(\/.+)?',
        name: 'visitNew',
        component: VisitNewView
    },
    {
        path: '/:locale(fa)/visit/:newID(\\d+):title(\/.+)?',
        name: 'visitNew-farsi',
        component: VisitNewView
    },
    {
        path: '/:locale(ar)/visit/:newID(\\d+):title(\/.+)?',
        name: 'visitNew-arabic',
        component: VisitNewView
    },
    {
        path: '/:school(' + schools.join("|") + ')/visit/:newID(\\d+):title(\/.+)?',
        name: 'schoolVisitNew',
        component: VisitNewView
    },
    {
        path: '/:locale(fa)/:school(' + schools.join("|") + ')/visit/:newID(\\d+):title(\/.+)?',
        name: 'schoolVisitNew-farsi',
        component: VisitNewView
    },
    {
        path: '/:locale(ar)/:school(' + schools.join("|") + ')/visit/:newID(\\d+):title(\/.+)?',
        name: 'schoolVisitNew-arabic',
        component: VisitNewView
    },
    {
        path: '/new/',
        name: 'newNew',
        component: NewNewView
    },
    {
        path: '/:locale(fa)/new/',
        name: 'newNew-farsi',
        component: NewNewView
    },
    {
        path: '/:locale(ar)/new/',
        name: 'newNew-arabic',
        component: NewNewView
    },
    {
        path: '/edit/:newID(\\d+):title(\/.+)?',
        name: 'editNew',
        component: NewNewView
    },
    {
        path: '/:locale(fa)/edit/:newID(\\d+):title(\/.+)?',
        name: 'editNew-farsi',
        component: NewNewView
    },
    {
        path: '/:locale(ar)/edit/:newID(\\d+):title(\/.+)?',
        name: 'editNew-arabic',
        component: NewNewView
    },
    {
        path: '/new-page/:menuID(\\d+)',
        name: 'newStaticPage',
        component: NewStaticPageView
    },
    {
        path: '/edit-page/:menuID(\\d+)/:pageID(\\d+)',
        name: 'editStaticPage',
        component: NewStaticPageView
    },
    {
        path: '/search/:query(.+)',
        name: "searchPage",
        component: NewsView
    },
    {
        path: '/:locale(fa)/search/:query(.+)',
        name: "searchPage-farsi",
        component: NewsView
    },
    {
        path: '/:locale(ar)/search/:query(.+)',
        name: "searchPage-arabic",
        component: NewsView
    },
    {
        path: '/:school(' + schools.join("|") + ')/:name(.+)',
        name: 'schoolVisitStaticPage',
        component: VisitStaticPageView
    },
    {
        path: '/:locale(fa)/:school(' + schools.join("|") + ')/:name(.+)',
        name: 'schoolVisitStaticPage-farsi',
        component: VisitStaticPageView
    },
    {
        path: '/:locale(ar)/:school(' + schools.join("|") + ')/:name(.+)',
        name: 'schoolVisitStaticPage-arabic',
        component: VisitStaticPageView
    },
    {
        path: '/:name(.+)',
        name: 'visitStaticPage',
        component: VisitStaticPageView
    },
    {
        path: '/:locale(fa)/:name(.+)',
        name: 'visitStaticPage-farsi',
        component: VisitStaticPageView
    },
    {
        path: '/:locale(ar)/:name(.+)',
        name: 'visitStaticPage-arabic',
        component: VisitStaticPageView
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // if (savedPosition) {
        //     return savedPosition
        // } else {
        //     return { top: 0 }
        // }
        // return {top: 0}

        return new Promise(resolve => {
            if (/firefox/ig.test(navigator.userAgent))
                setTimeout(() => {
                    resolve(savedPosition ?? { top: 0, left: 0 })
                }, 100)
            else
                resolve(savedPosition ?? { top: 0, left: 0 })
        })
    },
})

export default router
